/* eslint-disable react/jsx-props-no-spreading, react/no-array-index-key */
import React from 'react';

import Dropdown from '../Dropdown';
import {TComponentRef, formField, newFormField} from '../FormField';
import Option from '../Option';
import TextInput, {TProps as TTextInputProps, TValue} from '../TextInput';
import * as S from './style';

export type TProps = TComponentRef &
  TTextInputProps & {
    options?: string[];
    scrollTo?: number;
    renderHead?: (props: TTextInputProps) => React.ReactNode;
  };

export const InputPicker = React.memo<TProps>(({options, renderHead, scrollTo, ...inputProps}) => {
  const {value, onChange, disabled, readOnly} = inputProps;

  const head = renderHead ? (
    renderHead(inputProps)
  ) : (
    <TextInput autoComplete="off" {...inputProps} />
  );

  const overlay = React.useMemo(() => {
    if (disabled || readOnly) {
      return null;
    }

    return (options ?? []).map((option, index) => (
      <Option key={index} selected={option === value} onClick={onChange} value={option} />
    ));
  }, [disabled, readOnly, onChange, options, value]);

  return (
    <Dropdown
      scrollTo={scrollTo}
      hasVerticalPaddings
      head={head}
      overlay={overlay}
      disabled={disabled}
      readOnly={readOnly}
      overlayComponent={S.DropdownOverlay}
    />
  );
});

export default InputPicker;

export const InputPickerField = formField<TProps, TValue>(InputPicker);

export const NewInputPickerField = newFormField<TProps>(InputPicker);
/* eslint-enable react/jsx-props-no-spreading, react/no-array-index-key */
